module.exports = __webpack_public_path__ + "img/icon.8d9d302c.png";